module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sprouter",
    class: {
      disabled: _vm.disabled
    },
    on: {
      "mouseover": function($event) {
        _vm.hover = true
      },
      "mouseleave": function($event) {
        _vm.hover = false
      }
    }
  }, [_c('div', {
    staticClass: "sprouter-img"
  }, [_c('img', {
    attrs: {
      "src": _vm.img
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "name",
    class: {
      active: _vm.isActive, lighten: _vm.lighten
    }
  }, [_vm._v("\n    " + _vm._s(_vm.name) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "position"
  }, [_vm._v(_vm._s(_vm.position))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isActive),
      expression: "isActive"
    }],
    staticClass: "triangle"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-213e5047"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sectionTalking/Sprouter.vue
// module id = 668
// module chunks = 0